import React from 'react'
import { InfiniteScroll, List, PullToRefresh } from 'antd-mobile'
import { Container, Wrapper, Header } from '../Layout'
import PropTypes from 'prop-types'

const PAGE_SIZE = 30
const { Item } = List

class LogPage extends React.PureComponent {

  static propTypes = {
    title: PropTypes.string,
    api: PropTypes.string,
  }

  props = {
    title: '中奖记录',
  }

  state = (() => {
    return {
      loading: false,
      isLastPage: false,
      pageIndex: 1,
      listData: [],
    }
  })()

  render () {
    const { listData, isLastPage } = this.state
    const { title } = this.props
    return <Container>
      <Header>{title}</Header>
      <Wrapper flex>
        <PullToRefresh onRefresh={this.refresh}>
          <List>
            {listData.map((item, index) => {
              return <Item key={index} description={item['createTime']}>
                {item['giftDesc']}
              </Item>
            })}
            <div>
              <InfiniteScroll hasMore={!isLastPage} loadMore={this.loadMore}/>
            </div>
          </List>
        </PullToRefresh>
      </Wrapper>
    </Container>
  }

  refresh = async () => {
    const { api } = this.props
    let config = {
      url: api,
      params: {
        pageIndex: 1,
        pageSize: PAGE_SIZE
      }
    }
    await window.axios.request(config)
      .then(res => {
        const { list, isLastPage } = res
        // let { listData } = this.state
        this.setState({
          loading: false,
          isLastPage,
          pageIndex: 2,
          listData: list
        })
        window.toast.hide()
      })
      .catch(e => {
        console.error(e)
        window.toast.fail(e.message, 2)
      })
  }

  loadMore = async () => {
    const { api } = this.props
    const {
      pageIndex
    } = this.state
    let config = {
      url: api,
      params: {
        pageIndex,
        pageSize: PAGE_SIZE
      }
    }
    await window.axios.request(config)
      .then(res => {
        const { list, isLastPage } = res
        let { listData } = this.state
        this.setState({
          loading: false,
          isLastPage,
          pageIndex: pageIndex + 1,
          listData: [...listData, ...list]
        })
        window.toast.hide()
      })
      .catch(e => {
        this.setState({ isLastPage: true })
        console.error(e)
        window.toast.fail(e.message, 2)
      })
  }

}

export default LogPage
